import * as React from 'react';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { ListItem } from './ListItem';
import { IConfigItem } from './types';

interface IProps {
  items: IConfigItem[];
  onHideClick(index: number): void;
}

const SortableItem = SortableElement(ListItem);

const SortableList: React.FC<IProps> = ({ items, onHideClick }) => {
  return (
    <div>
      {items.map((item, index) => (
        <SortableItem
          key={item.id}
          index={index}
          order={index}
          data={item}
          onHideClick={onHideClick}
          disabled={item.hidden}
        />
      ))}
    </div>
  );
};

export default SortableContainer(SortableList);
